var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartCumulative = function SvgChartCumulative(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 4c0-.55228-.44772-1-1-1s-1 .44772-1 1v16c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1s-.4477-1-1-1h-15zm10.9451 3h-1.4451c-.2022 0-.3845-.12182-.4619-.30866s-.0346-.40189.1084-.54489l2.5-2.5c.1952-.19527.5118-.19527.7071 0l2.5 2.5c.143.143.1857.35805.1084.54489-.0774.18684-.2598.30866-.462.30866h-1.5448c-.4474 4.9539-4.1866 9.0524-9.17499 9.8838l-.61565.1026c-.54478.0908-1.06-.2772-1.1508-.822-.09079-.5448.27723-1.06.822-1.1508l.61565-.1026c4.02319-.6705 7.05399-3.9366 7.49369-7.911z",
    fill: "#000"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartCumulative, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart_cumulative.d6fb3135.svg";
export { ForwardRef as ReactComponent };